// extracted by mini-css-extract-plugin
module.exports = {"dashboard":"Dashboard_dashboard__2PQPT","searchBar_wrapper":"Dashboard_searchBar_wrapper__60hod"};